import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

interface Props {
  notificationId: string | number;
  onClose: () => void;
  onDelete: (uuid: string | number) => Promise<void> | void;
}

const DeleteModal: React.FC<Props> = (props) => {
  const { notificationId, onClose, onDelete } = props;

  const handleConfirm = async () => {
    await onDelete(notificationId);
    onClose();
  };

  return (
    <Dialog
      open
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
        },
      }}
    >
      {/* Header com X */}
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          p: 2,
          pb: 0,
        }}
      >
        <strong style={{ color: "#a7a7a7ff" }}># {notificationId}</strong>

        <IconButton
          aria-label="fechar"
          onClick={onClose}
          size="small"
          sx={{ color: "#4F4F4F" }}
        >
          <CloseIcon fontSize="large" />
        </IconButton>
      </DialogTitle>

      <DialogContent
        sx={{
          pt: 1,
          pb: 3,
          px: 4,
          textAlign: "center",
        }}
      >
        {/* Ícone de alerta */}
        <Box
          sx={{
            width: 72,
            height: 72,
            borderRadius: "50%",
            backgroundColor: "rgba(217, 31, 5, 0.08)", // rosa claro
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mx: "auto",
            mb: 3,
          }}
        >
          <WarningAmberIcon sx={{ fontSize: 36, color: "#D91F05" }} />
        </Box>

        {/* Título */}
        <Typography
          sx={{
            fontSize: 20,
            fontWeight: 700,
            color: "#333333",
            mb: 1.5,
          }}
        >
          Deseja excluir essa notificação?
        </Typography>

        {/* Texto de apoio */}
        <Typography
          sx={{
            fontSize: 14,
            color: "#828282",
            mb: 4,
          }}
        >
          Após a exclusão, não será possível visualizá-la
          <br />
          no Portal do Cliente.
        </Typography>

        {/* Botões */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: 3,
          }}
        >
          <Button
            onClick={onClose}
            size="large"
            sx={{
              textTransform: "none",
              color: "#D91F05",
              fontWeight: 600,
            }}
          >
            Cancelar
          </Button>

          <Button
            variant="contained"
            onClick={handleConfirm}
            size="large"
            sx={{
              textTransform: "none",
              backgroundColor: "#D91F05",
              fontWeight: 600,
              px: 4,
              "&:hover": {
                backgroundColor: "#bf1a04",
              },
            }}
          >
            Confirmar
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteModal;
